var React = require('react');

function NavIconsUser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m12 10.24a4.12 4.12 0 1 0 -4.12-4.12 4.12 4.12 0 0 0 4.12 4.12zm0-6.57a2.45 2.45 0 1 1 -2.45 2.45 2.45 2.45 0 0 1 2.45-2.45zm.64 7.57h-1.28a5.2 5.2 0 0 0 -5.19 5.19v5.57h11.66v-5.57a5.21 5.21 0 0 0 -5.19-5.19zm3.52 9.09h-8.32v-3.9a3.53 3.53 0 0 1 3.52-3.52h1.28a3.53 3.53 0 0 1 3.52 3.52z"}));
}

NavIconsUser.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsUser;

NavIconsUser.default = NavIconsUser;
